import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MapHelperService } from "../../../../../services/map-helper.service";
import { ValetParkingService } from '../../services/ValetParking.service';
import { Subscription } from 'rxjs';
import { addGeofencesRequestDTO } from 'src/app/features/geofences-map/models/addGeofences/addGeofencesRequestDTO';
import { GeofencesService } from 'src/app/features/geofences-map/services/Geofences.service';
import { EnumGeometryTypes } from 'src/app/features/shared/helpers/enums/EnumGeometryTypes';
import { EnumsService } from 'src/app/features/shared/services/ServiceCatalogEncapsulators/Enums.service';
import { SwalNotificationService } from 'src/app/features/shared/services/SwalNotification.service';

@Component({
  selector: 'app-valet-parking-map',
  templateUrl: './valet-parking-map.component.html',
  styleUrls: ['./valet-parking-map.component.css']
})
export class ValetParkingMapComponent {

  step: number = 1;
  identificador: string;
  options: string[] = ['10m', '20m', '50m', '80m', '100m'];
  selectedOption: string = '10m';
  mail: string  = "";
  phone: string  = "";
  valetParkingRequest: addGeofencesRequestDTO;

  subscription_InsertV2:Subscription;

  constructor(
    private mapHelperService: MapHelperService,
    private valetParkingService: ValetParkingService,
    private notifyService: SwalNotificationService,
    private GeofencesAPIService: GeofencesService,
    private enumCatalogsService: EnumsService,
    public dialogRef: MatDialogRef<ValetParkingMapComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.identificador = data.identificador;
  }

  ngOnInit(): void {
    this.createBuffer();
    this.mail = localStorage.getItem('user');
  }

  nextStep() {
    if (this.step < 2) {
      this.step++;
    }
  }

  prevStep() {
    if (this.step > 1) {
      this.step--;
    }
  }

  selectOption(option: string) {
    this.selectedOption = option;

    this.mapHelperService.bufferRadioKm = (parseInt(option.replace('m', '')))/1000;
    this.valetParkingService.radioKm = this.mapHelperService.bufferRadioKm;

    this.mapHelperService.UpdateValetParkingBuffer();
  }

  createBuffer(){
    this.selectedOption = '10m';
    this.valetParkingService.radioKm = (parseInt(this.selectedOption.replace('m', '')))/1000;

    this.mapHelperService.CreateValetParkingDragEvent();
  }

  SendData(){

    if(!this.mapHelperService.VerifyCarInValetParking(this.identificador)){
      this.notifyService.MessageError('El Vehículo no se encuentra dentro del radio establecido para Valet Parking');
      return;
    }

    if(this.mail == "" && this.phone == ""){
      this.notifyService.MessageError('Agregue un telefóno o correo de notificación');
      return;
    }

    var enums = this.enumCatalogsService.GetGeofenceEnums();

    if (this.valetParkingService.coordsValetParking.lat != 0 && this.valetParkingService.coordsValetParking.lng != 0) {
      this.valetParkingRequest = {
        identifiers: [this.identificador],
        coords : [[this.valetParkingService.coordsValetParking.lat.toString(), this.valetParkingService.coordsValetParking.lng.toString()]],
        multiplePolygonCoords: [],
        radio: this.valetParkingService.radioKm.toString(),
        name: "Valet Parking " + this.identificador,
        status: true,
        emailAlert: this.mail,
        phoneAlert: this.phone,
        idGeofenceCategory : Number(enums.GeofenceCategories.find(x => x.value == "Valet Parking").key),
        idGeofenceType: Number(enums.GeofenceTypes.find(x => x.value == "Area Segura - Alerta al Salir").key),
        // idGeofenceType: [Number(enums.GeofenceTypes.find(x => x.value == "Area Segura - Alerta al Salir").key)],
        idGeometryType: EnumGeometryTypes.Buffer,
        alarmType: "0",
        alarmFrecuency: "0",
        alarmDays: [],
        alarmIndividualTime: [],
        alarmRangeTime: [],
        guid: null
      }
      this.subscription_InsertV2 = this.GeofencesAPIService.InsertV2(this.valetParkingRequest).subscribe((data) => {
         console.log("RESPONSE",data);
         if(data.isSuccess){
           this.notifyService.MessageSuccessful("Actvado","Se ha activado el Valet Parking");
           this.valetParkingService.existValetParking = true;
           this.mapHelperService.DeleteValetParkingDragEvent();
           this.mapHelperService.UpdateLayerGeoJson("centerPointSource", this.mapHelperService.Empty_GeoJson);
           this.dialogRef.close(true);
         }else{
           this.notifyService.MessageError("No pudimos crear el área, contacte al administrador");
         }
       });
    }else{
      this.notifyService.MessageError("No se han seleccionado coordenadas para el Valet Parking");
    }
  }

  CloseDialog() {
    this.mapHelperService.DeleteValetParkingDragEvent();
    this.mapHelperService.ResetValetOParkingActiveBuffer();
    this.mapHelperService.UpdateLayerGeoJson("centerPointSource", this.mapHelperService.Empty_GeoJson);
    this.dialogRef.close(false);
  }

}
